export enum EducationStepsEnum {
  preStepEducationType = 'pre_step_education_type',
  generalBase = 'general_base',
  generalSecond = 'general_second',
  educationSkills = 'education_skills',
  educationActivities = 'education_activities',
  educationCoverPhoto = 'cover_photo',
  educationContact = 'education_contact',
  educationShare = 'education_share',
  congratulations = 'congratulations',
}
